import {
  ListProps,
  TextInput,
  DateInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectInput,
  NullableBooleanInput,
  AutocompleteInput,
  AutocompleteArrayInput,
  BulkDeleteButton,
} from "react-admin";
import { CustomList } from "../../components/CustomList";
import { useOptionsResource } from "../../shared/hooks/useOptionsResource";
import { initField, getDefaultListProps } from "../../shared/utils";
import { RouteSummaryDatagrid } from "./RouteSummaryDatagrid";
import {RouteSummaryHeader} from "./RouteSummaryHeader";
import {ReferenceArrayInputSubject} from "../../components/reference-inputs/ReferenceArrayInputSubject";


export const RouteSummaryList = (props: ListProps) => {
  const { data: options } = useOptionsResource("GET");
  const filters = options
    ? [
      <TextInput alwaysOn {...initField("id", options)} />,
      <DateInput {...initField("planned_date_after", options)} label="Pianificata dal" />,
      <DateInput {...initField("planned_date_before", options)} label="Pianificata al" />,
      <DateInput {...initField("planned_date__date", options)} label="Pianificata il" />,
      <SelectInput
        choices={options.status.choices}
        {...initField("status", options, "array")}
        alwaysOn
      />,
      <ReferenceInput
        {...initField("driver", options)}
        reference="autocomplete/employee"
        alwaysOn
      >
        <AutocompleteInput optionText="label" />
      </ReferenceInput>,
      <ReferenceInput
        {...initField("carrier", options)}
        filter={{ type: "carrier" }}
        reference="autocomplete/subject"
      >
        <AutocompleteInput optionText="label" />
      </ReferenceInput>,
      <ReferenceInput
        {...initField("vehicle", options)}
        reference="autocomplete/vehicle"
      >
        <AutocompleteInput optionText="label" />
      </ReferenceInput>,
      <ReferenceArrayInput
        {...initField("tags_filter", options)}
        label="Tag"
        reference="autocomplete/tag"
      >
        <AutocompleteArrayInput optionText="label" />
      </ReferenceArrayInput>,
          <ReferenceArrayInputSubject
              {...initField("start_points", options)}
              label="Magazzino competenza"
              className="filter-field-small"
              filter={{ type: "default_store" }}
              alwaysOn
          />
    ]
    : [];
  return options ? (
    <CustomList
      sort={{ field: "id", order: "DESC" }}
      filters={filters}
      {...getDefaultListProps(props)}
      bulkActionButtons={false}
      topElement={<RouteSummaryHeader/>}
    >
      <RouteSummaryDatagrid options={options} />
    </CustomList>
  ) : null;
};
